import uniq from 'lodash/uniq';

import { validateFormNodeWithNameCode } from './formNodeValidations';

export const validateFormData = (formNodes, liveErrors) => {
    const errors = formNodes
        .reduce((memo, formNode) => [...memo, ...validateFormNodeWithNameCode(formNode, formNodes, liveErrors)], [])
        .filter(Boolean);

    return uniq(errors);
};

export const isTemporaryId = (id) => /^_.*/.test(id);
